import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../../../components/button/button';
import styles from './filteritem.module.scss';
import Collapsible from '../../../../components/collapsible/Collapsible';
import FilterItem from './FilterItem';
import Clickable from '../../../../components/clickable/Clickable';

class FilterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: props.filter_Categories,
      selectedFilters: props.selectedFilters,
      filterObject: props.filter_Object,
      selectedFiltersValue: props.selectedFiltersValue
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  handleClickOutside = (event) => {
    const { cancel } = this.props;
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      cancel();
    }
  }

  handleFilterChange = (name, event) => {
    const { selectedFilters, filterObject } = this.state;
    const check = event.target.checked;
    const checkedValue = event.target.id;
    if (check) {
      this.setState({
        selectedFilters: [...selectedFilters, checkedValue]
      });
      if (filterObject?.[name]) {
        this.setState({
          filterObject: { ...filterObject, [name]: [...filterObject?.[name], checkedValue] }
        });
      } else {
        this.setState({
          filterObject: { ...filterObject, [name]: [checkedValue] }
        });
      }
    } else {
      const index = selectedFilters.indexOf(checkedValue);
      if (index > -1) {
        selectedFilters.splice(index, 1);
        this.setState({ selectedFilters });
      }
        this.setState({
          selectedFilters: [...selectedFilters.filter(element => (
            element !== checkedValue
          ))],

      filterObject: filterObject ? { ...filterObject,
            [name]: Array.isArray(filterObject[name]) ? [...filterObject[name].filter(element => (
              element !== checkedValue
          ))] : [] } : {}
        });
      }
      }

      handleFilterValueChange = (name, event) => {
        const { selectedFiltersValue } = this.state;
        const check = event.target.checked;
        const checkedValue = event.target.id;

        if (check) {
          this.setState({
            selectedFiltersValue: [...selectedFiltersValue, checkedValue]
          });
        } else {
          this.handleUncheckFilterValue(checkedValue);
        }
      };

      handleUncheckFilterValue = (checkedValue) => {
        const { selectedFiltersValue } = this.state;
        this.setState({
          selectedFiltersValue: selectedFiltersValue.filter(el => el !== checkedValue)
        });
      };

  handleClear = () => {
    const { setActiveTab, filterStyle } = this.props;
    this.setState({ selectedFilters: [], filterObject: [] });
    if (filterStyle) {
      this.setState({ selectedFiltersValue: [] });
      setActiveTab('open');
    }
  }

  render() {
    const { update, cancel, filterPostion,
        fromViolation,
        filterStyle
    } = this.props;
    const { selectedFilters,
        filters,
        filterObject, selectedFiltersValue } = this.state;
    return (
      <>
        <div className={`${filterPostion && styles.filterPostion} ${filterStyle && styles.filterStyle} ${styles.popup}`} ref={this.setWrapperRef}>
          <div className={styles.header}>
            <span className={styles.filterText}>
              <FormattedMessage id="components.filters" defaultMessage="Filters" />
            </span>
            <Clickable onClick={this.handleClear} className={styles.cancel} style={{ marginTop: '20px', marginLeft: '50px' }}>
              <FormattedMessage id="filters.form.clear" defaultMessage="Clear" />
            </Clickable>
            <Clickable onClick={cancel} className={styles.cancel} style={{ marginTop: '20px' }}>
              <FormattedMessage id="inspections.new.cancelBtn" defaultMessage=" Cancel" />
            </Clickable>
            <Button
              action="secondary"
              translationID="workorder.filter.apply"
              defaultText="Apply"
              onClick={() => update(selectedFilters, filterObject, selectedFiltersValue)}
              className={styles.btnPadding}
            />
          </div>
          <div className={styles.list}>
            {filters?.map(e => (
              <div key={e?.id}>
                {e.id !== 0 ? (
                <Collapsible title={e?.name} styleClasses={styles.rol} permit autoheight={false} openOnMount={e?.name === 'Types'}>
                  <FilterItem
                    id={e?.id}
                    filter={e}
                    type={fromViolation ? 'asset' : false}
                    handleChange={(id, targetId) => this.handleFilterChange(id, targetId)}
                    filterCategories={selectedFilters}
                  />
                </Collapsible>
                 ) : (
                  <FilterItem
                    id={e?.id}
                    filter={e}
                    type={false}
                    handleChange={(id, targetId) => this.handleFilterValueChange(id, targetId)}
                    filterCategories={selectedFiltersValue}
                  />
              )}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default FilterForm;
